function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.906 8.225C26 21.124 26 34.023 11.5 55.52h6.406a9.516 11.589 0 019.453-10.28 9.516 11.589 0 019.454 10.28h6.406c-14.5-21.498-14.5-34.397-15.406-47.296z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 5h2.719v3.225H26zM27.359 1.775V5M24.188 40.472l1.813-7.524h2.718l1.813 7.524h-6.344M26.453 29.723l.906-6.987.906 6.987h-1.812M18.07 40.472h18.578v2.15H18.07z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.469 31.335H33.25"
}));

var SvgEiffelTower = function SvgEiffelTower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEiffelTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eiffel Tower.b44cf6da.svg";
export { ForwardRef as ReactComponent };